

































































































































































































































import Vue, { PropType } from "vue";
import { GoldPurchasePaypalExistCardInformationFieldProps } from "@/components/GoldPurchase/GoldPurchasePaypalExistCardInformationField.vue";
import log from "loglevel";

export interface UsingCardCheckbox {
  is_register_card_information: boolean;
  is_register_as_autocharge_setting: boolean;
}

export interface PaypalCustomCardFieldsData {
  hasExistCard: boolean;
  stateCardSelected: string; // ラジオボタン "0": 登録済みのカード, "1": 新しいカード
  agreements: string[];
  needAgreementsAllowCount: number;
  isValid: boolean;
  hostedFields: any;
  usingCardCheckbox: UsingCardCheckbox;
}

export interface GoldPurchasePaypalInputCardInformationFormProps {
  sdkUrl: string;
  purchaseApiUrl: string;
  executeByPaymentInformationApiUrl: string;
  completedUrl: string;
  errorUrl: string;
  backUrl: string;
  autochargeUrl: string;
  usageStatus: string;
  clientToken: string;
  csrfToken: string;
  translationResources: object;
  termsOfUseUrl: string;
  informationUrl: string;
  goldTermsOfUseUrl: string;
  statusUsingPurchase: string;
  statusUsingAutocharge: string;
  amount: string;
  currentCard: any;
  deleteApiUrl: string;
  returnUrl: string;
  autochargeInputUrl: string;
  fraudNetUniqueId: string;
  paypalInputCardInformationFormWrappedRecaptchaProps: object;
}

export default Vue.extend({
  name: "vc-gold-purchase-paypal-input-card-information-form",
  props: {
    sdkUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["sdkUrl"]
      >,
      default: ""
    },
    purchaseApiUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["purchaseApiUrl"]
      >,
      default: ""
    },
    executeByPaymentInformationApiUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["executeByPaymentInformationApiUrl"]
      >,
      default: ""
    },
    completedUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["completedUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["errorUrl"]
      >,
      default: ""
    },
    backUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["backUrl"]
      >,
      default: ""
    },
    autochargeUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["autochargeUrl"]
      >,
      default: ""
    },
    usageStatus: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["usageStatus"]
      >,
      default: ""
    },
    clientToken: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["clientToken"]
      >,
      default: ""
    },
    csrfToken: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["csrfToken"]
      >,
      default: ""
    },
    translationResources: {
      type: Object as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["translationResources"]
      >,
      default: () => {}
    },
    termsOfUseUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["termsOfUseUrl"]
      >,
      default: ""
    },
    informationUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["informationUrl"]
      >,
      default: ""
    },
    goldTermsOfUseUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["goldTermsOfUseUrl"]
      >,
      default: ""
    },
    statusUsingPurchase: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["statusUsingPurchase"]
      >,
      default: "0"
    },
    statusUsingAutocharge: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["statusUsingAutocharge"]
      >,
      default: "0"
    },
    amount: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["amount"]
      >,
      default: "500"
    },
    currentCard: {
      type: [Object, Array] as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["currentCard"]
      >,
      default: () => {}
    },
    deleteApiUrl: {
      type: String as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["deleteApiUrl"]
      >,
      default: ""
    },
    returnUrl: {
      type: String as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["returnUrl"]
      >,
      default: ""
    },
    autochargeInputUrl: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["autochargeInputUrl"]
      >,
      default: ""
    },
    fraudNetUniqueId: {
      type: String as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["autochargeInputUrl"]
      >,
      default: ""
    },
    paypalInputCardInformationFormWrappedRecaptchaProps: {
      type: Object as PropType<
        GoldPurchasePaypalInputCardInformationFormProps["paypalInputCardInformationFormWrappedRecaptchaProps"]
      >,
      default: () => {}
    }
  },
  mounted() {
    this.needAgreementsAllowCount = document.getElementsByName(
      "agreements"
    ).length;

    // "0": 登録済みのカードがない, "1": 登録済みのカードがある
    this.hasExistCard = this.statusUsingPurchase === "1";

    // ラジオボタンの初期値 "0": 登録済みのカード, "1": 新しいカード
    this.stateCardSelected = this.hasExistCard ? "0" : "1";

    // Mac/Safariブラウザバック対策：デフォルト状態に戻す
    window.addEventListener("beforeunload", e => {
      this.usingCardCheckbox.is_register_card_information = false;
      this.usingCardCheckbox.is_register_as_autocharge_setting = true;
      this.agreements = [];
    });

    // iPhone/Safariブラウザバック対策：デフォルト状態に戻す
    window.addEventListener("pageshow", event => {
      if (event.persisted) {
        this.usingCardCheckbox.is_register_card_information = false;
        this.usingCardCheckbox.is_register_as_autocharge_setting = true;
        this.agreements = [];
      }
    });

    // Edgeブラウザバック対策：デフォルト状態に戻す
    setTimeout(() => {
      this.resetCheckboxToDefault();
    }, 300);
  },
  data(): PaypalCustomCardFieldsData {
    return {
      needAgreementsAllowCount: 1,
      hasExistCard: true,
      stateCardSelected: "0", // ラジオボタン "0": 登録済みのカード, "1": 新しいカード
      agreements: [],
      isValid: false,
      hostedFields: {},
      usingCardCheckbox: {
        is_register_card_information: false,
        is_register_as_autocharge_setting: true
      }
    };
  },
  computed: {
    isUseNewCard(): boolean {
      // ラジオボタン "0": 登録済みのカード, "1": 新しいカード
      return this.stateCardSelected === "1";
    },
    isUsingAutocharge(): boolean {
      // 利用状況 1: 利用中, 0: 利用していない
      return this.statusUsingAutocharge === "1";
    },
    isNeedAgreementsAllChecked(): boolean {
      return this.needAgreementsAllowCount === this.agreements.length;
    },
    requestBody(): object {
      return {
        purchase_amount: this.amount,
        is_register_card_information: this.usingCardCheckbox
          .is_register_card_information,
        is_register_as_autocharge_setting: this.usingCardCheckbox
          .is_register_as_autocharge_setting
      };
    },
    purchaseRequestBody(): object {
      return {
        purchase_amount: this.amount,
        is_use_registered_setting: !this.isUseNewCard,
        is_register_card_information: this.usingCardCheckbox
          .is_register_card_information,
        is_register_as_autocharge_setting: this.usingCardCheckbox
          .is_register_as_autocharge_setting
      };
    },
    executeByPaymentInformationRequestBody(): object {
      return {
        purchase_amount: this.amount,
        fraud_net_unique_id: this.fraudNetUniqueId
      };
    }
  },
  methods: {
    catchValid(value: boolean) {
      this.isValid = value;
    },
    catchHostedFields(value: object) {
      this.hostedFields = value;
    },
    catchIsDeleted() {
      this.hasExistCard = false;
      this.stateCardSelected = "1"; // ラジオボタン "0": 登録済みのカード, "1": 新しいカード
    },
    resetCheckboxToDefault() {
      let checkboxRegisterCard = document.getElementById(
        "set-card-purchase"
      ) as HTMLInputElement;
      checkboxRegisterCard.checked = this.usingCardCheckbox.is_register_card_information;
      let checkboxAutoCharge = document.getElementById(
        "set-card-autocharge"
      ) as HTMLInputElement;
      checkboxAutoCharge.checked = this.usingCardCheckbox.is_register_as_autocharge_setting;
    }
  }
});
